// extracted by mini-css-extract-plugin
export var buttons = "_az-0";
export var buttonsActive = "_az-h";
export var cancelConfirm = "_az-1";
export var closeButton = "_az-2";
export var column = "_az-3";
export var container = "_az-4";
export var detailHeader = "_az-6";
export var detailTitle = "_az-7";
export var detailsContent = "_az-5";
export var header = "_az-8";
export var headerWithClose = "_az-9";
export var icon = "_az-a";
export var infoIcon = "_az-c";
export var informationContainer = "_az-b";
export var sideDrawer = "_az-d";
export var sideDrawerOpen = "_az-e";
export var stickyFooter = "_az-f";
export var typeOption = "_az-g";